const documentTypes = [
  {
    id: "freelance-agreement",
    title: "Freelance Agreement",
    description: "Create a contract for freelance services with clear terms and payment conditions",
    category: "business"
  },
  {
    id: "nda",
    title: "Non-Disclosure Agreement",
    description: "Protect your confidential information with a legally binding NDA",
    category: "business"
  },
  {
    id: "terms-and-conditions",
    title: "Terms and Conditions",
    description: "Create comprehensive terms and conditions for your website or business",
    category: "website"
  },
  {
    id: "employment-contract",
    title: "Employment Contract",
    description: "Create a formal agreement between employer and employee with clear terms",
    category: "employment"
  },
  {
    id: "privacy-policy",
    title: "Privacy Policy",
    description: "Generate a privacy policy that complies with GDPR, CCPA and other regulations",
    category: "website"
  },
  {
    id: "rental-agreement",
    title: "Rental Agreement",
    description: "Create a comprehensive lease agreement for residential property",
    category: "real-estate"
  },
  {
    id: "cease-and-desist",
    title: "Cease and Desist Letter",
    description: "Formally request that an individual or organization stop an unauthorized activity",
    category: "legal"
  },
  {
    id: "invoice-template",
    title: "Professional Invoice",
    description: "Create a professional invoice for your services or products",
    category: "business"
  },
];

export default documentTypes;
